import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import { SentryErrorFallback } from './components/SentryErrorFallback.tsx';
import './index.css';
import { AuthProvider } from './lib/auth.tsx';
import { KiprDataProvider } from './lib/kiprData.ts';
import { initSentry } from './lib/sentry';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />} showDialog={false}>
      <AuthProvider>
        <KiprDataProvider>
          <App />
        </KiprDataProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
